exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".csv_with_logo {\n  -webkit-print-color-adjust: exact;\n}\n.csv_with_logo .main-image {\n  position: absolute;\n  height: 210mm;\n  max-width: initial;\n  width: initial;\n}\n.csv_with_logo .thelogo {\n  position: absolute;\n  height: 40mm;\n  width: 40mm;\n  background-size: contain;\n  background-repeat: no-repeat;\n}\n.csv_with_logo.TR .main-image {\n  right: 0;\n  top: 0;\n}\n.csv_with_logo.TR .thelogo {\n  top: 8mm;\n  right: 8mm;\n  background-position-y: 50%;\n}\n.csv_with_logo.BR .main-image {\n  right: 0;\n  bottom: 0;\n}\n.csv_with_logo.BR .thelogo {\n  right: 8mm;\n  bottom: 8mm;\n  background-position-y: 100%;\n}\nvideo {\n  height: 80VH;\n  margin-left: auto;\n  margin-right: auto;\n  position: relative;\n  margin-top: 5VH;\n  display: block;\n}\n@media print {\n  body {\n    -webkit-print-color-adjust: exact;\n  }\n}\n@page {\n  size: A4 landscape;\n  margin: 2mm 2mm 2mm 2mm;\n  -webkit-print-color-adjust: exact;\n}", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /Users/matthijs/projects/PHILIPS/philips-dental-pro/shop/src/app/components/asset-library/preview-or-print/preview-or-print.component.scss
// module id = ../../../../../src/app/components/asset-library/preview-or-print/preview-or-print.component.scss
// module chunks = main